export { StandardPill } from './StandardPill';
